import { DateTime } from '@app/@core/models';
import { UserRoles } from '@app/@graphql/models';

export interface AuthState {
  accessToken: string;
  refreshToken: string;
  accessTokenExpirationDate: DateTime;
  refreshTokenExpirationDate: DateTime;
  roles: UserRoles[];
  userName?: string;
  userId: string;
}

export function createAuthState(state?: Partial<AuthState>): AuthState {
  return { accessToken: null, refreshToken: null, accessTokenExpirationDate: null, refreshTokenExpirationDate: null, roles: [], userName: null, userId: null, ...state };
}
